export default "__VITE_ASSET__DyRwrbCJ__"